import { NgClass, NgSwitch, NgSwitchCase, NgSwitchDefault } from '@angular/common';
import { AfterViewInit, Component } from '@angular/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatTooltip } from '@angular/material/tooltip';
import { IActionFieldMeta, MetaDataService } from '../../meta-data.service';
import { BaseActionComponent } from '../base-action.component';
import { Substitute } from './substitute';

@Component({
  selector: 'app-action-substitute',
  templateUrl: './substitute.component.html',
  imports: [
    NgSwitch,
    ReactiveFormsModule,
    NgSwitchCase,
    NgSwitchDefault,
    MatTooltip,
    NgClass
  ],
  styleUrls: ['../action.component.scss']
})
export class SubstituteComponent extends BaseActionComponent implements AfterViewInit {

  private static getDefaultValue(type: string): any {
    switch (type) {
      case 'STRING':
        return '';
      default:
        return null;
    }
  }

  truncWarningToolTip = 'Note: Depending on the max length of the field,'
    + ' length of the current string and the length of the string to be substituted, the result string may be truncated.  ';
  private substitute: Substitute;
  replacementControl: FormControl;
  substituteControl: FormControl;

  constructor(protected metaDataService: MetaDataService) {
    super(metaDataService);
  }

  protected initialiseControls() {
    this.substituteControl = new FormControl();
    this.replacementControl = new FormControl();
  }

  ngAfterViewInit() {
    this.substitute = this.actionData.value ?
        new Substitute(this.actionData.value.substituteValue, this.actionData.value.replaceWith) :
        new Substitute(null, null);
    if (!this.actionData.value) {
      this.valueControl.setValue(null);
      this.substituteControl.setValue(null);
      this.replacementControl.setValue(null);
    } else {
      Object.entries(this.actionData.value).forEach(([key, value]) => {
        if (key === 'substituteValue') {
          this.substituteControl.setValue(value);
        } else if (key === 'replaceWith' ) {
          this.replacementControl.setValue(value);
        }
      });
      this.valueControl.setValue(this.substitute);
    }

    this.substituteControl.valueChanges.subscribe(value => this.substituteValueChange(value));
    this.replacementControl.valueChanges.subscribe(value => this.valueControlChange(value));
    this.valueControl.valueChanges.subscribe(_ => this.valueControlValueChange());
    this.valueControlValueChange();

    setTimeout(() => {
      this.getMeta(this.destinationDescriptorControl.value)
        .subscribe((filteredMeta: IActionFieldMeta[]) => {
          const selField = filteredMeta.find(fm => fm.fieldName === this.destinationControl.value);
          this.sourceControl.setValidators(null);
          this.destinationControl.setValidators(Validators.required);
          this.destinationControlValueChange(selField);
        });
    }, 0);
  }

  protected destinationControlValueChange(selectedField: IActionFieldMeta): void {

    if (!selectedField) {
      this.valueControl.setValue(null);
      this.destinationTypeControl.setValue(null);
      return;
    }

    if (this.destinationTypeControl.value !== selectedField.metaType)
      this.valueControl.setValue(SubstituteComponent.getDefaultValue(selectedField.metaType));

    this.substituteControl.setValidators(Validators.required);

    this.destinationTypeControl.setValue(selectedField.metaType);
  }

  private substituteValueChange(value: String): void {
    if (value === '') {
      this.valueControl.setErrors({invalid: true});
    } else {
      this.substitute.setSubstituteValue = value;
      this.valueControl.setValue(this.substitute);
      this.valueControl.markAsDirty();
    }
  }

  private valueControlChange(value: String): void {
    this.substitute.setReplaceWith = value;
    this.valueControl.setValue(this.substitute);
    this.valueControl.markAsDirty();
  }

  private valueControlValueChange(): void {
    // TODO redundant logic is just updated with Paired Entities update
    this.getMeta(this.destinationDescriptorControl.value)
      .subscribe((filteredMeta: IActionFieldMeta[]) => {
        const dstField = filteredMeta.find(fm => fm.fieldName === this.destinationControl.value);
      });

    if (this.substitute.getSubstituteValue === null) {
      this.valueControl.setErrors({invalid: true});
    }
  }
}
